'use client'

import { PageWithHeader } from 'app/(auth)/_components'
import { NextPage } from 'next'
import VideoDetailContent from '~/features/video_detail/components/VideoDetailContent'

type Props = {
  params: { id: string }
}

const Page: NextPage<Props> = ({ params }) => {
  return (
    <PageWithHeader>
      <VideoDetailContent id={params.id} />
    </PageWithHeader>
  )
}

export default Page
